import { Button } from "antd";
import Play from "icons/Play.svg";
import Pause from "icons/Pause.svg";
import FrameUp from "icons/FrameUp.svg";
import FrameUpDisabled from "icons/FrameUpDisabled.svg";
import { ReactComponent as MinusIcon } from "icons/minusIcon.svg";
import styles from "./styles.module.scss";
import {
  BaseballSetPosition,
  BaseballLiftPoisiton,
  BaseballLandPosition,
  BaseballReleasePosition,
  BaseballFinishPosition,
  BatterP1,
  BatterP2,
  BatterP3,
  BatterP4,
  BatterP5,
  BatterP6,
} from "./icons";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { useMemo, useState } from "react";
import { HandSpeedGraph } from "pages/simulation-visualize/components";

export function BaseballSeekbar({
  isReadyToPlay,
  handlePlay,
  isPlaying,
  handlePreviousFrame,
  timestamps,
  currentFrame,
  handleSliderChange,
  handleNextFrame,
  isControlsDisabled,
  hideSeekbar,
  isLandscape,
  isDrawing,
  min,
  max,
  setCurrentFrame,
  isBaseBallVariant,
  totalCount,
  positions,
  timeBarDuration,
  positionTimestamps,
  handSpeedData,
  graphTimeVlaues,
  timeAtEveryPosition,
  fps,
  movement_type,
  isLoading,
}: any) {
  const [showGraph, setShowGraph] = useState(false);
  const containerClassName = styles.seekbarColumn;
  const drawingLandscape = isLandscape && isDrawing ? true : false;

  function isMinusBtnDisabled() {
    if (currentFrame <= min) return true;
  }

  function isPlusBtnDisabled() {
    return timestamps ? currentFrame >= (max || timestamps?.length - 1) : false;
  }

  function handleClickPositionIcon(frameNum: any) {
    setCurrentFrame(frameNum);
  }

  const width = document?.getElementById("range")?.clientWidth || 0;

  const widthOfIconsContainer = width - 24;

  let marginBox = 1;
  const sizeofIcon = 50;

  // formula to find the center of icon box
  if (width) {
    marginBox = ((sizeofIcon / width) * 100) / 2;
  }

  function getBaseballCriticalEvents(positions: any) {
    if (!positions) return;
    return [
      {
        key: "p1-set",
        positionFrame: positions["set"],
        icon: BaseballSetPosition,
        adjustmentFactor: 0.3,
      },
      {
        key: "p2-lift",
        positionFrame: positions["lift"],
        icon: BaseballLiftPoisiton,
        adjustmentFactor: -0.25,
      },
      {
        key: "p3-Stride Initiation",
        positionFrame: positions["Stride Initiation"],
        icon: BaseballLandPosition,
        adjustmentFactor: 0.04,
      },
      {
        key: "p4-front foot contact",
        positionFrame: positions["front foot contact"],
        icon: BaseballLandPosition,
        adjustmentFactor: 0.04,
      },
      {
        key: "p5-Max-Separation",
        positionFrame: positions["Max-Separation"],
        icon: BaseballLandPosition,
        adjustmentFactor: 0.04,
      },
      {
        key: "p6-Acceleration",
        positionFrame: positions["Acceleration"],
        icon: BaseballLandPosition,
        adjustmentFactor: 0.04,
      },
      {
        key: "p7-release",
        positionFrame: positions["release"],
        icon: BaseballReleasePosition,
        adjustmentFactor: -0.1,
      },
      {
        key: "p8-finish",
        positionFrame: positions["finish"],
        icon: BaseballFinishPosition,
        adjustmentFactor: 0,
      },
    ];
  }

  function getBaseballCriticalEventsBatter(positions: any) {
    if (!positions) return;
    return [
      {
        key: "p1-stance",
        positionFrame: positions["p1"],
        icon: BatterP1,
        adjustmentFactor: 0.3,
      },
      {
        key: "p2-load",
        positionFrame: positions["p2"],
        icon: BatterP2,
        adjustmentFactor: 0,
      },
      {
        key: "p3-first move",
        positionFrame: positions["p3"],
        icon: BatterP3,
        adjustmentFactor: 0,
      },
      {
        key: "p4-foot contact",
        positionFrame: positions["p4"],
        icon: BatterP4,
        adjustmentFactor: 0,
      },
      // { key: "impact", positionFrame: positions?.["impact"], icon: BatterP4 },
      {
        key: "p5- max separation",
        positionFrame: positions["p5"],
        icon: BatterP5,
        adjustmentFactor: 0,
      },
      {
        key: "p6-swing initiation",
        positionFrame: positions["p6"],
        icon: BatterP6,
        adjustmentFactor: 0.4,
      },
      {
        key: "p7-impact",
        positionFrame: positions["impact"],
        icon: BatterP6,
        adjustmentFactor: 0.4,
      },
      {
        key: "p8-finish",
        positionFrame: positions["p7"],
        icon: BatterP6,
        adjustmentFactor: 0.4,
      },
    ];
  }

  const baseballCriticalEvents = useMemo(
    () =>
      movement_type === "batter"
        ? getBaseballCriticalEventsBatter(positions)
        : getBaseballCriticalEvents(positions),
    [positions],
  );

  const leftPositions: any = useMemo(
    () =>
      baseballCriticalEvents?.map((item) => {
        return ((item.positionFrame - min) / (max - min)) * 100;
      }),
    [positions, min, max],
  );

  const isAllPositionsFound = useMemo(
    () => baseballCriticalEvents?.every((item) => item.positionFrame),
    [positions],
  );

  let minLeft: any = null;
  let maxLeft: any = null;

  if (leftPositions) {
    minLeft = Math.min(...leftPositions);
    maxLeft = Math.max(...leftPositions);
  }

  const WidthOfTimebar = maxLeft - minLeft;

  const leftPositionForBatterOrPicture =
    (((movement_type === "batter" ? positions?.["p1"] : positions?.["set"]) -
      min) /
      (max - min)) *
    100;

  return (
    <>
      <div
        className={
          isLandscape
            ? styles.landscapeCustomControlsRowContainer
            : styles.customControlsRowContainer
        }
        style={{
          visibility: `${hideSeekbar ? "hidden" : "visible"}`,
          justifyContent: `${drawingLandscape} ? "center" : ""}`,
          // pointerEvents: isReadyToPlay ? "auto" : "none",
        }}
      >
        <div className={styles.customControlsRow}>
          <div className={containerClassName}>
            <div
              style={{
                height: "30px",
                width: "30px",
                cursor: "pointer",
                pointerEvents: currentFrame <= (min || 0) ? "none" : "auto",
              }}
              className={styles.minusBtn}
            >
              <MinusIcon height={30} width={30} onClick={handlePreviousFrame} />
            </div>

            <Button
              className={styles.rangeBtn}
              onClick={handlePlay}
              disabled={isControlsDisabled}
              style={{ border: "none" }}
            >
              <img
                src={isPlaying ? Pause : Play}
                alt="play-pause-icon"
                style={{ height: "30px" }}
              />
            </Button>

            <div style={{ position: "relative", width: "100%" }}>
              <input
                id="range"
                type="range"
                min={min || 0}
                max={max || timestamps?.length - 1}
                value={currentFrame}
                onChange={handleSliderChange}
                disabled={isControlsDisabled}
              />
              <ConditionalRenderer condition={isBaseBallVariant && positions}>
                <div
                  className={styles.criticalEventsContainer}
                  style={{
                    width: `${widthOfIconsContainer}px`,
                    transform: "translate(-50%, 0)",
                    left: "50%",
                  }}
                >
                  {baseballCriticalEvents?.map((item, index) => {
                    const Icon = item.icon;
                    // const adjustmentFactor = index === 0 ? 0.3 : 0;
                    return (
                      <ConditionalRenderer
                        condition={item.positionFrame && positions}
                      >
                        <Icon
                          key={item.key}
                          onClick={() =>
                            handleClickPositionIcon(item.positionFrame)
                          }
                          className={styles.positionsIcon}
                          style={{
                            left: `${
                              ((item.positionFrame - min) / (max - min)) * 100 -
                              marginBox +
                              item?.adjustmentFactor
                            }%`,
                          }}
                        />
                      </ConditionalRenderer>
                    );
                  })}
                </div>

                <ConditionalRenderer
                  condition={isAllPositionsFound && positions}
                >
                  <ConditionalRenderer condition={!isLoading && handSpeedData}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "red",
                      }}
                    >
                      <div
                        className={styles.handSpeedGraph}
                        style={{
                          width: `${WidthOfTimebar - 1.45}%`,
                        }}
                      >
                        <HandSpeedGraph
                          positions={positions}
                          data={handSpeedData}
                          graphTimeVlaues={graphTimeVlaues}
                          positionTimestamps={positionTimestamps}
                          setShowGraph={setShowGraph}
                          timeAtEveryPosition={timeAtEveryPosition}
                          setCurrentFrame={setCurrentFrame}
                          fps={fps}
                        />
                      </div>
                    </div>
                  </ConditionalRenderer>
                  <div
                    className={styles.timeBar}
                    style={{
                      width: `${WidthOfTimebar + 2}%`,
                      left: `${leftPositionForBatterOrPicture - 1}%`,
                    }}
                    onMouseEnter={() => setShowGraph(true)}
                    onMouseLeave={() => setShowGraph(false)}
                  >
                    Total Time:&nbsp;
                    <span className={styles.time}>
                      {timeBarDuration?.toFixed(2)} sec
                    </span>
                  </div>
                  <div
                    className={styles.lineForTimebar}
                    style={{
                      width: `${WidthOfTimebar}%`,
                      left: `${leftPositionForBatterOrPicture}%`,
                    }}
                  ></div>
                </ConditionalRenderer>
              </ConditionalRenderer>
            </div>
            <Button
              onClick={handleNextFrame}
              disabled={isPlusBtnDisabled()}
              className={styles.rangeBtn}
            >
              <img
                src={isControlsDisabled ? FrameUpDisabled : FrameUp}
                alt=""
                height={30}
              />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
